// extracted by mini-css-extract-plugin
export default {"root":"styles-root-d7523b","content":"styles-content-ecee46"};